import { useEffect } from 'react'

const BLOCKING_OVERLAY_SELECTOR = [
  '[data-slot="dialog-content"][data-state="open"]',
  '[data-slot="sheet-content"][data-state="open"]',
  '[data-slot="alert-dialog-content"][data-state="open"]',
].join(',')

/** Keep the app background unavailable while a body-portaled overlay is open. */
export function useOverlayIsolation(): void {
  useEffect(() => {
    const root = document.getElementById('root')
    if (!root) return

    const initialInert = root.inert
    const initialAriaHidden = root.getAttribute('aria-hidden')
    const initialBodyOverflow = document.body.style.overflow
    let isolated = false

    const restore = () => {
      root.inert = initialInert
      document.body.style.overflow = initialBodyOverflow
      if (initialAriaHidden === null) root.removeAttribute('aria-hidden')
      else root.setAttribute('aria-hidden', initialAriaHidden)
    }

    const update = () => {
      const shouldIsolate = Boolean(document.querySelector(BLOCKING_OVERLAY_SELECTOR))
      if (shouldIsolate) {
        isolated = true
        root.inert = true
        document.body.style.overflow = 'hidden'
        root.setAttribute('aria-hidden', 'true')
      } else if (isolated) {
        isolated = false
        restore()
      }
    }

    update()
    const observer = new MutationObserver(update)
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-state'],
      childList: true,
      subtree: true,
    })

    return () => {
      observer.disconnect()
      if (isolated) restore()
    }
  }, [])
}
